module.exports = {
  titleCardOptions: {
    title: '需求描述',
    showMore: false,
    isSwitch: false,
  },
  resultDetails: [
    {
      title: '',
      contents: [
        '一种。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。',
      ],
    },
  ],
};
